import { DS } from '@/design-system'
import { View } from 'react-native'
import { ActivityIndicator, ViewStyle } from 'react-native'

export const LoaderSpinner = ({
  type = 'On Dark',
  containerStyle
}: { type?: 'On Light' | 'On Dark'; containerStyle?: ViewStyle }) => (
  <View style={[containerStyle]}>
    <ActivityIndicator
      size={'small'}
      color={type === 'On Light' ? DS.palette['Global/Black'] : DS.palette['Global/White']}
    />
  </View>
)
